import { observer } from "mobx-react-lite";
import { useCallback } from "react";

import { PagingOptions } from "@libs/api/dtos/index.ts";
import {
  XeroFinancialSyncData,
  XeroFinancialSyncStatus
} from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { InfiniteScrollList } from "@ui-components/InfiniteScrollList/InfiniteScrollList.tsx";

import { useIntegrationScreenContext } from "../context/IntegrationScreenContext.ts";
import { XeroSyncHistoryListItem } from "./Xero/XeroSyncHistoryListItem.tsx";

interface XeroSyncHistoryListProps {
  refreshKey: string;
  showAll: boolean;
}

export const XeroSyncHistoryList = observer(
  ({ refreshKey, showAll }: XeroSyncHistoryListProps) => {
    const { customIntegrationXero } = useStores();
    const { xeroTenantId } = useIntegrationScreenContext();

    const getItems = useCallback(
      (query: PagingOptions) => {
        return customIntegrationXero.getFinancialSyncData({
          ...query,
          targetTenantId: xeroTenantId,
          statuses: showAll
            ? undefined
            : [
                XeroFinancialSyncStatus.Warnings,
                XeroFinancialSyncStatus.Errors,
                XeroFinancialSyncStatus.InternalFailure
              ]
        });
      },
      [customIntegrationXero, showAll, xeroTenantId]
    );

    return (
      <InfiniteScrollList
        refreshKey={refreshKey}
        detailsListStyles={{ root: { overflow: "hidden" } }}
        getItems={getItems}
        columns={[
          {
            name: "",
            key: "details",
            minWidth: 500,
            maxWidth: 700,
            onRender: (item: XeroFinancialSyncData) => (
              <XeroSyncHistoryListItem data={item} />
            )
          }
        ]}
      />
    );
  }
);
